module.exports = __webpack_public_path__ + "media/tap-to-save.c8a0026b.mp4";